var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 6",
    id: "Layer_6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.39,17.46V46.54a4.64,4.64,0,0,1-4.62,4.63H17.18a4.64,4.64,0,0,1-4.62-4.62V17.46a4.64,4.64,0,0,1,4.62-4.63H45.77"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50.44,
    cy: 14.13,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 39.03,
    cy: 25,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.77,20.32a3.75,3.75,0,0,0-3.47,3.74V39.94a3.77,3.77,0,0,0,3.76,3.76h8.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.65,43.7h7.29a3.77,3.77,0,0,0,3.76-3.76V24.06a3.77,3.77,0,0,0-3.76-3.76H24.06a1.37,1.37,0,0,0-.29,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34,26.74A5.64,5.64,0,1,0,37.64,32"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.5226a0789052f43c7849e402e033e494.svg";
export { ForwardRef as ReactComponent };